import TurndownService from "turndown";
import html2Unicode from "@alexbosworth/html2unicode";

type TurndownRule = {
  key: string;
  rule: TurndownService.Rule;
};

class PostFormatter {

  public static async html2Unicode(html: string) : Promise<string> {
    let unistr: string = "";

    if (html.length > 0) {
      unistr = await html2Unicode.html2unicode(html);
    }
    return unistr;
  }

  public static facebookTurndownRules(): TurndownRule[] {
    const rules: TurndownRule[] = [];

    // Rule for bold
    rules.push({
      key: 'bold',
      rule: {
        filter: ['strong', 'b'],
        replacement: (content: string) => `${content}`, // `*${content}*`,
      },
    });

    // Rule for italic
    rules.push({
      key: 'italic',
      rule: {
        filter: ['em', 'i'],
        replacement: (content: string) => `${content}`, // `_${content}_`,
      },
    });

    // Rule for line breaks
    rules.push({
      key: 'lineBreak',
      rule: {
        filter: 'br',
        replacement: () => '\n',
      },
    });

    // Rule for paragraphs (convert to double newlines)
    rules.push({
      key: 'paragraph',
      rule: {
        filter: 'p',
        replacement: (content: string) => `${content}\n\n`,
      },
    });

    // Rule for unordered lists
    rules.push({
      key: 'unorderedList',
      rule: {
        filter: 'ul',
        replacement: (content: string) => `\n${content}`,
      },
    });

    rules.push({
      key: 'unorderedListItem',
      rule: {
        filter: 'li',
        replacement: (content: string) => `- ${content}\n`,
      },
    });

    // Rule for ordered lists
    rules.push({
      key: 'orderedList',
      rule: {
        filter: 'ol',
        replacement: (content: string) => `\n${content}`,
      },
    });

    rules.push({
      key: 'orderedListItem',
      rule: {
        filter: 'li',
        replacement: (content: string, node: Node): string => {
          const parent = node.parentNode as HTMLElement | null;
          if (!parent) return content;
          const index = Array.from(parent.children).indexOf(node as HTMLElement) + 1;
          return `${index}. ${content}\n`;
        },
      },
    });

    // Rule for links
    rules.push({
      key: 'link',
      rule: {
        filter: (node: Node): boolean => {
          return node.nodeName === 'A' && (node as HTMLElement).getAttribute('href') !== null;
        },
        replacement: (content: string, node: Node): string => {
          const href = (node as HTMLElement).getAttribute('href') || '';
          return `[${content}](${href})`;
        },
      },
    });

    return rules;
  }
}

export default PostFormatter;